module.exports = __webpack_public_path__ + "img/logo-plusdin.e7b361f2.svg";